import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getDateFormat = store => store[NAME].dateFormat;
export const getSkills = store => store[NAME].skills;